// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"040c0656","522":"81b750e2","787":"6b9fef68"}[chunkId] + ".chunk.css";
};